
  import { Component, Vue } from "vue-property-decorator";
  import Telesalud from "@/components/Municipalidad/Telesalud.vue";
  
  @Component({
    components: {
        Telesalud
    }
  })
  export default class TelesaludView extends Vue {}
  